import { FaPhone, FaEnvelope } from 'react-icons/fa';
import styles from './styles/fab.module.css';

import { logPhoneCallClick } from "../helpers/google-analytics/gaEvents";

const FAB = () => {
  const isMobile = window.innerWidth <= 768;
  const pathname = window.location.pathname;
  const hash = window.location.hash;

  if (!isMobile && (pathname === '/contact-us' || hash === '#/contact-us')) {
    return null;
  }

  return (
    <div className={styles.fabContainer}>
      {isMobile ? (
        <a className={styles.link} aria-label="Phone number" href="tel:+15064588801" title="Click to call" onClick={logPhoneCallClick}>
          <FaPhone size={20} className={styles.icon} />
        </a>
      ) : (
        <a className={`${styles.link} ${styles.long}`} aria-label="Contact Us" href="/#/contact-us" title="Click to contact us">
          <FaEnvelope size={20} className={styles.icon} />
          <span>Let's Talk!</span> {/* Text on desktop FAB */}
        </a>
      )}
    </div>
  );
};

export default FAB;
